import { NO_REGULATION_DESCRIIPTION, NO_REGULATION_TITLE } from '../../../constants/constants';
import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';

export const NoRegulations = () => (
  <>
    <Heading color="abyss" variant="sm">
      {NO_REGULATION_TITLE}
    </Heading>
    <Text className="text-abyss" variant="md">
      {NO_REGULATION_DESCRIIPTION}
    </Text>
  </>
);
